

class IndexController {
    constructor($state) {
        'ngInject';
        this.$state = $state
    }

    login() {
        console.log("Logged in")
        this.$state.go('pages.dashboard')
    }
}

export const IndexComponent = {
    name: 'index',
    component: {
        template: `
        <div class="main-content">
            <div class="intro">
                <div class="intro-container">
                    <div class="left">
                        <img class="welcome" src="/app/img/welcome-mms-plus-blue.png"/>
                        <h1>Simple Medication Management for You and Your Loved Ones</h1>
                        <span>Download the <b>FREE</b> mobile app from the iOS App Store or Google Play Store</span> 
                        <app-store-links></app-store-links>                
                    </div>                
                    <img class="app-overview-img" src="/app/img/app-promote/app-overview.png">  
                                    
                </div>
            </div>
            <div class="signup-mobile-message">
                <span><strong>Already Signed up?</strong></span>
                <span>You may also view and print your med schedule online from a computer at <a>www.MyMedSchedule.com</a>.</span>
                <span>Logging into <a>www.MyMedSchedule.com</a> is not supported on mobile devices</span>
            </div>
            <div class="signing-up padding">
                <h2>Signing up is simple:</h2>
                <div class="howto">
                    <div class="uses-map">
                        <span class="title">If your doctor or hospital uses the MedActionPlan platform:</span> 
        
                        <span class="text">They can set up your account, including the medication list. You will receive an invite email to help you sign in to your account. 
                        The email will come from info4@medactionplan.com.</span> 
                    </div>
                    <div class="does-not-use-map">
                        <span class="title">If your doctor or hospital does NOT use the MedActionPlan platform:</span> 
        
                        <span class="text">Open the mobile app and tap the button “Sign Up Now” in the app. 
                        Complete the form, then sign in and tap the + icon to start adding your medications.</span>
                    </div>                
                </div>
                
                <app-functions class="pl-0"></app-functions>
                
                <div class="trusted">
                    <h2 class="pb-4">Trusted by healthcare provides since 2004</h2>
        
                    MyMedSchedule and MedActionPlan programs have been used and trusted by hundreds of thousands of 
                    healthcare providers across hundreds of healthcare systems to help patients and caregivers follow their med schedules.
                </div>
            </div>
            <mms-footer></mms-footer>
        </div>        
        <div class="login">
            <h2>Already have an account?</h2>
            
            MyMedSchedule Plus supports viewing and printing medication calendars from the web.
            
            <h2>Sign in</h2> 
            <login-form email-address="" on-login="$ctrl.login()"></login-form>
            
            <span class="you-must-signup">You must sign up first before accessing the web version</span>
            
            <span class="limitation">The web view is currently limited to viewing and printing medication calendars. Please download the mobile app for the full functionality</span>
        </div>
        `,
        controller: IndexController,
        bindings: {
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/pages/index/index.component.js